import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ItemDetails } from '../../_models/item/item-details.model';
import { Global } from 'src/app/globals';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators, UntypedFormControl, AbstractControl, FormControl } from '@angular/forms';
import { CustomerRequest } from 'src/app/_models/customer/customer-request.model';
import { CustomerDetails } from 'src/app/_models/customer/customer-details.model';
import { AlertService } from 'src/app/_services/alert.service';
import { CustomerServiceProvider } from 'src/app/_services/customer.service';
import * as Sentry from '@sentry/angular';
import { CustomerCredit } from 'src/app/_models/customer/customer-credit.model';
import { BookingRequest } from 'src/app/_models/booking/booking-request.model';
import { BookingServiceProvider } from 'src/app/_services/booking.service';
import { AppSettingsServiceProvider } from 'src/app/_services/app-settings.service';
import { MatStepper, } from '@angular/material/stepper';
import utils from 'src/app/utils';
import { OrederRemarks } from 'src/app/_models/order/order-remarks.model';
import { PendingAgreementConfig } from 'src/app/_models/booking/pending-agreement-config';
import { GatewayServiceProvider } from 'src/app/_services/gateway.service';
import { ASRAppSettings, ErrorMessages, PDFLinkPlaceHolder, PendingAgreementsConfiguration, StorageKeys, TIME_SLOTS, TransactionType, WareHouseStaggingSettings } from 'src/app/_constants';
import { RequestHelperProvider } from 'src/app/_services/request-helper';
import { CryptoService } from 'src/app/_services/crypto.service';
import { ItemServiceProvider } from 'src/app/_services/item.service';
import Utils from './../../utils';
import { Helpers } from 'src/app/_models/helpers';
import { EmailContent } from 'src/app/_models/booking/email-content';
import { BookingPostingErrorTypes, ItemSearchType } from 'src/app/enums';
import { WareHouseProConfig } from 'src/app/_models/warehouse-pro/warehouse-pro-config.model';
import { RouteDataProvider, StagingServiceProvider, StorageServiceProvider } from 'src/app/_services/services';
import { CustomEvents } from 'src/app/_services/custom-events';
import { Router, ActivatedRoute } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { ItemListComponent } from '../shared/item-list/item-list.component';
import { ItemSearchComponent } from '../shared/item-search/item-search.component';
import { FarmAndFieldsComponent } from '../shared/farm-field/farm-field.component';
import { CustomerListComponent } from '../shared/customer-list/customer-list.component';
import { CustomerSearchComponent } from '../shared/customer-search/customer-search.component';
import { AppSignaturePadComponent } from '../shared/signature-pad/signature-pad.component';
import { LoadingService } from 'src/app/_services/loading.service';
import { ItemRequest } from 'src/app/_models/item/item-request.model';



@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.css'],
    standalone: true,
    imports: [
        SharedModule,
        MaterialModule,
        ItemListComponent,
        ItemSearchComponent,
        FarmAndFieldsComponent,
        CustomerListComponent,
        CustomerSearchComponent
    ],
})
export class OrderComponent implements OnInit {
    private static readonly noOpSpan = { finish: () => undefined };
    customerFormGroup: UntypedFormGroup;
    farmAndFieldGroup: UntypedFormGroup;
    statusFormGroup: UntypedFormGroup;
    productsFormGroup: UntypedFormGroup;
    reviewFormGroup: UntypedFormGroup;
    customers: CustomerDetails[] = null;
    items: ItemDetails[] = null;
    orderRemarks: OrederRemarks[] = null;
    isEditable = true;
    customerHeading = 'Search Customer To Ship To';

    bookingRequest: BookingRequest;
    customerRequest: CustomerRequest;
    customerLimitType: number;
    isBillToSearch: boolean = false;
    isShipToSearch: boolean = false;
    orderStatuses: any;
    showStatusValidationError: boolean = false;
    orderField1: string;
    orderField2: string;
    orderField3: string;
    defaultPriceLevel: string;
    sellingPrice1Label: string;
    sellingPrice2Label: string;
    isSignatureRequired: boolean;
    selectedItem: ItemDetails;
    unitPricePrecision: number;
    productQuantityPrecision: number;
    addedItems: ItemDetails[] = [];
    customerPriceLevel: string;
    isEditItem: boolean;
    isShowAllItems: boolean;
    minDate: Date;
    @ViewChild('stepper')
    stepper: any;
    // stepper: MatStepper;
    totalAmount: number;
    isSign: boolean = false;
    public signatureImage: string;
    isAutoPost = false;
    public emailContent: EmailContent;
    public myMath = Math;
    productCategoryDateRange: any[] = [];

    OrderSignatureRequiredStatus: boolean = false;
    QuoteButtonName: string = "Quote";
    public timeSlots: any[] = TIME_SLOTS;
    public requireTheirDocumentNumber: boolean = false;

    isfarmAndFields: boolean = false;
    selectedFarmAndField: string;
    splits: [];
    showFarmAndFields: boolean = false;

    @ViewChild('signature')
    public signaturePad!: AppSignaturePadComponent;


    public pendingAgreementConfig: PendingAgreementConfig = {
        pendingAgreementStatus: false,
        emailType: "",
        pendingBookingStatus: "",
        pendingBookingStatusDescription: "",
        pendingPrepayStatus: "",
        pendingPrepayStatusDescription: "",
        pendingOrderStatus: "",
        pendingOrderStatusDescription: "",
        pendingQuoteStatus: '',
        pendingQuoteStatusDescription: '',
        PendingSignatureRequiredStatus: false,
        ButtonQuote: "Quote",
        ButtonBooking: "Book",
        ButtonPrepay: "Prepay",
        SameBookingNumberConfig: false,
        RemarkNumberForBookingProgram: "",
        RemarkNumberForFarmAndField: "",
    };

    productsForm: boolean = false;
    public isLinear: boolean = true;

    public shipmentTimeRemarksNumber: string = "";
    public shipmentTypeRemarksNumber: string = "";
    public deliveryPointRemarksNumber: string = "";

    public deliveryPoints: any[] = [];
    public isSalesProUser: boolean = false;

    public ItemSearchType = ItemSearchType.SalesOrder;

    public showAddNewDeliveryPointForm: boolean;
    private pendingHistoryCopyData: any;
    private isHistoryCopyLoaded: boolean = false;
    private openCopiedOrderReview: boolean = false;
    private isHistoryCopyBootstrapInProgress: boolean = false;
    private copiedOrderType: string;
    private copiedPriceLevel: string;
    private copiedBillToCustomerId: string;
    public activeStepIndex: number = 0;




    constructor(private appSetting: AppSettingsServiceProvider,
        private staging: StagingServiceProvider,
        public bookingService: BookingServiceProvider,
        public gatewayService: GatewayServiceProvider,
        public alertService: AlertService,
        public customerServiceProvider: CustomerServiceProvider,
        public globals: Global,
        public requestHelper: RequestHelperProvider,
        public cryptoService: CryptoService,
        private _formBuilder: UntypedFormBuilder,
        private router: Router, private route: ActivatedRoute,
        private itemServiceProvider: ItemServiceProvider,
        private storage: StorageServiceProvider,
        private dataProvider: RouteDataProvider,
        private events: CustomEvents,
        private blockUI: LoadingService) {
        this.showAddNewDeliveryPointForm = false;
        this.bookingRequest = new BookingRequest();
        this.bookingRequest.customerInfo = undefined;
        this.bookingRequest.billToCustomer = undefined;
        this.bookingRequest.creditInfo = undefined;
        this.isEditItem = false;
        this.isShowAllItems = false;
        this.totalAmount = 0;
        if (this.route.snapshot.params['from'] === 'historycopy') {
            this.isHistoryCopyBootstrapInProgress = true;
            this.blockUI.start();
        }
        this.getOrderData();
        this.getPricision();
        //this.setDefaultDates();
        this.getUsersPermission();
        this.getOrderRemarks(true);
        this.GetProductCategoryDateRange();
    }

    private stopBlockUI(force: boolean = false) {
        if (force || !this.isHistoryCopyBootstrapInProgress) {
            this.blockUI.stop();
        }
    }

    private finishHistoryCopyBootstrap() {
        this.isHistoryCopyBootstrapInProgress = false;
        this.blockUI.stop();
    }

    private startOrderTransaction(name: string) {
        try {
            const sentryAny = Sentry as unknown as { startSpan?: (context: { name: string }) => { finish?: () => void } };
            const span = sentryAny.startSpan ? sentryAny.startSpan({ name }) : null;
            return span || OrderComponent.noOpSpan;
        } catch {
            return OrderComponent.noOpSpan;
        }
    }

    async ngOnInit() {
        this.customerFormGroup = this._formBuilder.group({
            credit: ['', Validators.required]
        });
        this.statusFormGroup = this._formBuilder.group({
            deliveryPointName: [''],
            allowsHeavyTruck: [false],
            orderField1: [''],
            orderField2: [''],
            orderField3: ['']
        });
        this.productsFormGroup = this._formBuilder.group({
            quantity: ['', Validators.required],
            price: ['', Validators.required],
            uom: [''],
            orderLineRemarks: [''],
            shipmentTime: [''],
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            addedItems: ['', Validators.min(0)]
        });
        this.reviewFormGroup = this._formBuilder.group({
        });
        this.GetPendingAgreementSettings();
        await this.getAndSetWarehouseProConfigurations();

        let wsConfig: WareHouseProConfig = this.storage.get(WareHouseStaggingSettings.ModuleName);
        if (wsConfig.WarehousePro == true) {
            this.shipmentTypeRemarksNumber = wsConfig.RemarkConfigurationForShipmentType;
            this.shipmentTimeRemarksNumber = wsConfig.RemarkConfigurationForShipmentTime;
            this.deliveryPointRemarksNumber = wsConfig.RemarkConfigurationForDeliveryPoint;
        }

        this.isSalesProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false;

        if (this.route.snapshot.params['from'] === 'historycopy') {
            this.pendingHistoryCopyData = this.dataProvider.storage;
            this.tryLoadHistoryCopyData();
        }
    }

    async getAndSetWarehouseProConfigurations() {
        try {
            let modules = await this.appSetting.getModules();
            if (modules && modules.length) {
                let wsModule = modules.find((x: any) => x.ModuleName == WareHouseStaggingSettings.ModuleName);
                let wsModuleId = wsModule ? wsModule.ModuleId : null;
                if (wsModuleId) {
                    let agentId = this.storage.AgentID;
                    let tenantId = this.storage.getTenantID();
                    let wsConfig = new WareHouseProConfig();
                    let configurations = await this.appSetting.getConfigurations(wsModuleId);


                    let config = configurations.find((x: any) => x.ConfigurationKey === WareHouseStaggingSettings.Settings.Warehouse_Pro && x.Agent == agentId);
                    if (config) {
                        wsConfig.WarehousePro =
                            JSON.parse(config.ConfigurationValue) &&
                                JSON.parse(config.ConfigurationValue).Selected
                                ? true
                                : false;
                    }

                    configurations = configurations.filter(x => x.Agent == agentId && x.Dataset == tenantId);

                    for (let i = 0; i < configurations.length; i++) {
                        let config = configurations[i];
                        let value = config.ConfigurationValue ? config.ConfigurationValue : null;
                        let key = config.ConfigurationKey ? config.ConfigurationKey : null;
                        switch (key) {
                            case WareHouseStaggingSettings.Settings.RemarkConfigurationForShipmentType: { }
                                wsConfig.RemarkConfigurationForShipmentType = value;
                                break;
                            case WareHouseStaggingSettings.Settings.RemarkConfigurationForShipmentTime:
                                wsConfig.RemarkConfigurationForShipmentTime = value;
                                break;
                            case WareHouseStaggingSettings.Settings.RemarkConfigurationForDeliveryPoint:
                                wsConfig.RemarkConfigurationForDeliveryPoint = value;
                                break;
                        }
                    }

                    Object.assign(this.appSetting.warehouseProConfig, wsConfig);
                    localStorage.setItem(WareHouseStaggingSettings.ModuleName, JSON.stringify(wsConfig));
                }
            }
        } catch (ex) {
            throw ex;
        }
    }



    // canvasResize() {
    //     let canvas = document.querySelector('canvas')
    //     if (this.signaturePad) {
    //         this.signaturePad.set('minWidth', 1);
    //         this.signaturePad.set('canvasWidth', (window.outerHeight > window.outerWidth ? window.outerWidth - 75 : window.outerHeight - 75).toString());
    //         this.signaturePad.set('canvasHeight', 200);
    //     }
    //     else if (canvas) {
    //         canvas.width = window.outerWidth;
    //     }
    // }

    ngAfterViewInit() {
        if (this.signaturePad) {
            this.signaturePad.clear();
        }

        if (this.openCopiedOrderReview) {
            this.openCopiedOrderInReview();
        }
    }

    // drawComplete(event: MouseEvent | Touch) {
    //     // will be notified of szimek/signature_pad's onEnd event
    //     console.log('Completed drawing', event);
    //     console.log(this.signaturePad.toDataURL());
    //     let Signatureimage1: String = this.signaturePad.toDataURL();
    //     let Signatureimage2: string = Signatureimage1.replaceAll("data:image/png;base64,", "");
    //     console.log(Signatureimage2);
    //     this.signatureImage = this.signaturePad.toDataURL();

    //     this.bookingRequest.salesOrder.signatureImage = Signatureimage2;
    //     this.showImage(event);
    // }
    drawComplete(signatureDataUrl?: string | Event) {
        const signatureImage = typeof signatureDataUrl === 'string'
            ? signatureDataUrl
            : this.signaturePad?.toDataUrl() || '';

        console.log('Completed drawing');
        console.log(signatureImage);
        if (this.isSignatureRequired) {
            if (!signatureImage || this.signaturePad.isEmpty()) {

                utils.confirmationDialog('Warning', "Signature is Required.", 'Close', (result) => {
                    if (result == 'Close') {
                        this.resign();
                        this.signaturePad.clear();
                        this.signatureImage = undefined;
                        this.OrderSignatureRequiredStatus = true;
                    }

                }, false);


            }
            else {
                let Signatureimage2: string = this.getSignaturePayload(signatureImage);
                console.log(Signatureimage2);
                this.signatureImage = signatureImage;
                this.bookingRequest.salesOrder.signatureImage = Signatureimage2;

                this.showImage();
            }
        }
        else {

            let Signatureimage2: string = this.getSignaturePayload(signatureImage);
            console.log(Signatureimage2);
            this.signatureImage = signatureImage;
            this.bookingRequest.salesOrder.signatureImage = Signatureimage2;

            this.showImage();
        }



    }

    drawStart() {
        console.log('Start drawing');
    }

    clear() {
        this.OrderSignatureRequiredStatus = this.isSignatureRequired ? true : false;
        this.signaturePad.clear();
    }

    private getSignaturePayload(signatureImage: string): string {
        return signatureImage.replace(/^data:image\/png;base64,/, '');
    }



    atLeastOne = (validator: ValidatorFn) => (
        group: UntypedFormGroup,
    ): ValidationErrors | null => {
        const hasAtLeastOne =
            group &&
            group.controls &&
            Object.keys(group.controls).some(k => !validator(group.controls[k]));

        return hasAtLeastOne ? null : { atLeastOne: true };
    };
    // validate() {
    //     this.showStatusValidationError = !this.salesOrder.pickup && !this.salesOrder.delivery;
    // }
    ngAfterViewChecked() {
        // this.blockUI.stop();
    }
    smallerThan(otherControlName: string) {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (!control.parent) {
                return null; // Control is not yet associated with a parent.
            }
            const thisValue = control.value;
            const otherValue = control.parent.get(otherControlName).value;
            if (thisValue < otherValue) {
                return null;
            }

            return {
                'smallerthan': true
            }
        };
    }

    greaterThan(otherControlName: string) {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (!control.parent) {
                return null; // Control is not yet associated with a parent.
            }
            const thisValue = control.value;
            const otherValue = control.parent.get(otherControlName).value;
            if (thisValue > otherValue) {
                return null;
            }

            return {
                'greaterthan': true
            }
        };
    }
    receiveCustomers($event) {
        this.customers = $event.customer;
        this.customerRequest = $event.request;
    }
    GetProductCategoryDateRange() {
        this.blockUI.start();
        this.appSetting.GetAppSettingsFromASR(ASRAppSettings.ProductCategoryDateRange).then((response) => {
            this.productCategoryDateRange = response.TransactionObject;

            this.stopBlockUI();

        }).catch((error) => {
            if (error)
                this.alertService.error(error.Message);
            this.stopBlockUI();
        })
    }
    receiveSelectedCustomer($event) {
        if (this.isBillToSearch) {
            this.isBillToSearch = false;
            this.bookingRequest.billToCustomer = $event.customerDetails;
            this.customerPriceLevel = this.bookingRequest.billToCustomer && this.bookingRequest.billToCustomer.priceLevel ? this.bookingRequest.billToCustomer.priceLevel : this.defaultPriceLevel;
            this.emailContent = new EmailContent(this.bookingRequest.billToCustomer.mailToEmails, PDFLinkPlaceHolder, true);
            this.getCreditDetails(this.bookingRequest.billToCustomer);
        }
        else if (this.isShipToSearch) {
            this.isShipToSearch = false;
            this.bookingRequest.customerInfo = $event.customerDetails;
            // this.customerPriceLevel = this.bookingRequest.customerInfo.priceLevel ? this.bookingRequest.customerInfo.priceLevel : this.defaultPriceLevel;
            this.getBilltoCustomer($event);
        }
        else {
            this.bookingRequest.customerInfo = $event.customerDetails;

            this.deliveryPoints = this.bookingRequest.customerInfo.deliveryPoints;
            this.deliveryPoints = [...this.deliveryPoints].sort((a, b) => a.Value.localeCompare(b.Value));

            // if (this.deliveryPoints.length)
            // this.bookingRequest.salesOrder.deliveryPointId = this.deliveryPoints[0].Key;

            //this.customerPriceLevel = this.bookingRequest.customerInfo.priceLevel ? this.bookingRequest.customerInfo.priceLevel : this.defaultPriceLevel;
            this.getBilltoCustomer($event);
        }

        this.requireTheirDocumentNumber = this.bookingRequest.customerInfo.requireTheirDocumentNumber == 'Y' ? true : false;
        if (this.requireTheirDocumentNumber) {
            this.reviewFormGroup.addControl("documentNumber", new FormControl('', Validators.required));
        }
        else {
            this.reviewFormGroup.removeControl("documentNumber");
            this.bookingRequest.salesOrder.documentNumber = "";
        }
        console.log("requireTheirDocumentNumber =>", this.bookingRequest.customerInfo.requireTheirDocumentNumber);
        console.log("RequireTheirDocumentNumber =>", this.requireTheirDocumentNumber);
    }
    getBilltoCustomer($event) {
        this.blockUI.start();
        this.customerServiceProvider.getBillToCustomer(this.bookingRequest.customerInfo.nameId).then((billToNameId) => {
            let billToRequest = new CustomerRequest();
            billToRequest.nameId = billToNameId;
            this.customerServiceProvider.GetCustomersLive(billToRequest, (billToCustomer) => {
                this.stopBlockUI();
                if (billToCustomer.length > 0) {
                    this.bookingRequest.billToCustomer = billToCustomer[0];
                    this.customerPriceLevel = this.copiedPriceLevel || (this.bookingRequest.billToCustomer && this.bookingRequest.billToCustomer.priceLevel ? this.bookingRequest.billToCustomer.priceLevel : this.defaultPriceLevel);
                    if (this.isAutoPost) {
                        this.emailContent = new EmailContent(this.bookingRequest.billToCustomer.mailToEmails, PDFLinkPlaceHolder, this.isAutoPost);
                    }
                    this.getCreditDetails(this.bookingRequest.billToCustomer);
                    this.applyCopiedBillToCustomerOverride();
                }
                else {
                    this.alertService.error('Customer (type) "X" or "d" or "c" is not included in the current Name ID search range. Go to Settings (Select Name ID type Range) and increase the range to use this id.');
                    this.bookingRequest.customerInfo = null;
                    this.customers = null;
                }
            }, (error) => {
                this.stopBlockUI();
                this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : error.Message);
            }, this.pendingAgreementConfig.emailType);
        }).catch(() => {
            this.stopBlockUI();
            this.bookingRequest.billToCustomer = $event.customerDetails;
            if (this.isAutoPost) {
                this.emailContent = new EmailContent(this.bookingRequest.billToCustomer.mailToEmails, PDFLinkPlaceHolder, this.isAutoPost);
            }
            this.customerPriceLevel = this.copiedPriceLevel || (this.bookingRequest.billToCustomer && this.bookingRequest.billToCustomer.priceLevel ? this.bookingRequest.billToCustomer.priceLevel : this.defaultPriceLevel);
            this.getCreditDetails(this.bookingRequest.billToCustomer);
            this.applyCopiedBillToCustomerOverride();
        });
    }
    changeShipTo() {
        this.customerHeading = 'Search Customer To Ship To';
        this.bookingRequest.customerInfo = undefined;
        this.customers = undefined;
        this.customerRequest = undefined;
        this.isShipToSearch = true;
        this.setActiveStep(0);
    }
    changeBillTo() {
        this.customerHeading = 'Search Customer To Bill To';
        this.bookingRequest.billToCustomer = undefined;
        this.customers = undefined;
        this.customerRequest = undefined;
        this.isBillToSearch = true;
        this.setActiveStep(0);
    }
    getCreditDetails(customer: CustomerDetails): Promise<any> {
        this.blockUI.start();
        return new Promise((resolve, reject) => {
            this.customerServiceProvider.GetCustomerCreditDetails(customer.nameId).then((credit: CustomerCredit) => {
                if (this.addedItems.length > 0) {
                    this.recalculateAddedItem();
                }
                this.stopBlockUI();
                this.bookingRequest.creditInfo = credit;//$event.customerCredit;
                if (Number(customer.salesCreditLimit) < 0) {
                    this.customerLimitType = -1
                } else if (Number(customer.salesCreditLimit) == 0) {
                    this.customerLimitType = 0
                } else {
                    this.customerLimitType = Number(customer.salesCreditLimit);
                }
                resolve(true);
            }).catch((error) => {
                console.log(error);
                Sentry.captureMessage("Handled Error" + error);
                this.alertService.error(error.Message);
                reject(error);
            });
        });
    }
    recalculateAddedItem() {
        this.addedItems.forEach((item) => {
            if (!(item as any).isCopiedPriceLocked) {
                if (this.customerPriceLevel == '2')
                    item.price = item.priceLevel2;
                else
                    item.price = item.priceLevel1;
            }
            item.amount = Number((item.price * item.quantity));
        });
        this.UpdateTotal();
    }
    getOrderData() {
        this.blockUI.start();
        this.orderStatuses = [];
        this.orderStatuses.push({ id: 'A', value: 'Active' })
        this.bookingRequest.salesOrder.orderStatus = this.orderStatuses[0].id;
        this.bookingService.GetPackageSetupToken('INV').then((data) => {
            this.stopBlockUI();
            this.getOrderStatus(Object.create(data));
            this.getOrderFields(Object.create(data));
            this.getDefaultDelivery(Object.create(data));
            this.getDefaultPriceLevel(Object.create(data));
            this.tryLoadHistoryCopyData();
        });
    }

    private tryLoadHistoryCopyData() {
        if (this.isHistoryCopyLoaded || !this.pendingHistoryCopyData || !this.orderStatuses || this.orderStatuses.length === 0) {
            return;
        }

        this.isHistoryCopyLoaded = true;
        this.loadHistoryCopyData(this.pendingHistoryCopyData);
    }

    private loadHistoryCopyData(data: any) {
        const copyData = data ? JSON.parse(JSON.stringify(data)) : null;
        this.dataProvider.storage = undefined;

        if (!(copyData && copyData.items && copyData.items.length > 0)) {
            this.alertService.warning('History order details not found.', false, true);
            return;
        }

        const customerId = this.getHistoryCopyCustomerId(copyData);
        if (!customerId) {
            this.alertService.error('Unable to copy this record because the customer could not be identified.');
            return;
        }

        const itemIds = copyData.items
            .map(item => this.getHistoryCopyItemId(item))
            .filter(itemId => !!itemId)
            .join(',');

        if (!itemIds) {
            this.alertService.warning('Unable to copy this record because no item details were found.', false, true);
            return;
        }

        this.blockUI.start();
        const customerRequest = new CustomerRequest();
        customerRequest.name = customerId;

        this.customerServiceProvider.GetCustomer(customerRequest, async (response) => {
            if (response.length !== 1) {
                this.alertService.warning('History customer detail not found.', false, true);
                this.finishHistoryCopyBootstrap();
                return;
            }

            this.receiveSelectedCustomer({ customerDetails: response[0] });
            this.applyCopiedOrderHeader(copyData.history);
            // Must finish before the items are built, as each item carries the delivery point in its remarks.
            await this.restoreCopiedDeliveryPoint(copyData);

            const itemRequest = new ItemRequest();
            itemRequest.id = itemIds;
            this.itemServiceProvider.getItemsByIds(itemRequest, (itemsResponse: any) => {
                if (!itemsResponse || itemsResponse.length === 0) {
                    this.alertService.warning('History item details not found.', false, true);
                    this.finishHistoryCopyBootstrap();
                    return;
                }

                const copiedItems: ItemDetails[] = [];
                copyData.items.forEach(historyItem => {
                    const productId = this.getHistoryCopyItemId(historyItem);
                    const item = itemsResponse.find(i => i.itemId === productId);
                    if (!item) {
                        return;
                    }

                    const clone = JSON.parse(JSON.stringify(item));
                    const quantity = this.getHistoryCopyItemQuantity(historyItem);
                    clone.quantity = quantity;
                    clone.price = this.getHistoryCopyItemPrice(historyItem);
                    clone.amount = Number(clone.price * quantity);
                    clone.orderlineRemarks = historyItem.OrderLineRemarks || historyItem.orderlineRemarks || historyItem.LineRemarks || '';
                    clone.lineRemarks = clone.orderlineRemarks;
                    clone.shipmentTime = this.getHistoryCopyRemarkValue(historyItem, this.shipmentTimeRemarksNumber)
                        || historyItem.ShipmentTime || historyItem.shipmentTime || clone.shipmentTime;
                    clone.itemBalance.Location = historyItem.Location || clone.itemBalance.Location || Utils.getLocation();
                    clone.IsPriceOveridden = !!historyItem.IsPriceOveridden;
                    copiedItems.push(this.prepareOrderItemForDraft(this.resetCopiedOrderItemDates(clone), true));

                    if (!this.copiedPriceLevel) {
                        const inferredLevel = this.inferHistoryCopyPriceLevel(historyItem, item);
                        if (inferredLevel) {
                            this.copiedPriceLevel = inferredLevel;
                            this.customerPriceLevel = inferredLevel;
                        }
                    }
                });

                this.addedItems = copiedItems;
                this.items = null;
                this.selectedItem = null;
                this.isEditItem = false;
                this.UpdateTotal();
                this.openCopiedOrderInReview();
                this.alertService.warning('Ship/Pickup dates were reset for the copied order. Review and update them before submitting.', false, true);
                this.finishHistoryCopyBootstrap();
            }, (error) => {
                this.finishHistoryCopyBootstrap();
                if (error.Message)
                    this.alertService.error(error.Message);
            });
        }, (error) => {
            this.finishHistoryCopyBootstrap();
            if (error.Code == 401)
                this.alertService.error('Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.');
            else if (error.Message)
                this.alertService.error(error.Message);
        });
    }

    private applyCopiedOrderHeader(history: any) {
        if (!history) {
            return;
        }

        this.bookingRequest.salesOrder.orderType = this.getHistoryCopyOrderType(history) || this.bookingRequest.salesOrder.orderType;
        this.copiedOrderType = this.bookingRequest.salesOrder.orderType;

        this.bookingRequest.salesOrder.orderStatus = history.OrderStatus || history.orderStatus || this.bookingRequest.salesOrder.orderStatus;
        this.bookingRequest.salesOrder.orderField1 = history.OrderField1 || history.orderField1 || this.bookingRequest.salesOrder.orderField1;
        this.bookingRequest.salesOrder.orderField2 = history.OrderField2 || history.orderField2 || this.bookingRequest.salesOrder.orderField2;
        this.bookingRequest.salesOrder.orderField3 = history.OrderField3 || history.orderField3 || this.bookingRequest.salesOrder.orderField3;

        const priceLevel = this.getHistoryCopyPriceLevel(history);
        if (priceLevel) {
            this.copiedPriceLevel = priceLevel;
            this.customerPriceLevel = priceLevel;
        }

        this.copiedBillToCustomerId = history.BillToCustomerId || history.billToCustomerId || '';
    }

    private async restoreCopiedDeliveryPoint(copyData: any) {
        // The copy flow bypasses the customer list, which is what normally loads the customer's delivery points.
        if (this.isSalesProUser && this.bookingRequest.customerInfo) {
            const options = await this.staging.GetCustomerDeliveryPointOptions(this.bookingRequest.customerInfo.nameId);
            this.bookingRequest.customerInfo.deliveryPoints = options;
            this.deliveryPoints = [...options].sort((a, b) => a.Value.localeCompare(b.Value));
        }

        const copiedKey = this.getHistoryCopyDeliveryPointId(copyData);
        if (!copiedKey) {
            return;
        }

        // Keys are length-capped when stored, so compare them in their normalized form.
        const normalizedKey = StagingServiceProvider.NormalizeDeliveryPointKey(copiedKey);
        let match = this.deliveryPoints.find(dp => StagingServiceProvider.NormalizeDeliveryPointKey(dp.Key) === normalizedKey);
        if (!match) {
            // Keep the original selection visible and submittable even if it is not in the customer's current list.
            const separatorIndex = normalizedKey.indexOf(' - ');
            match = { Key: normalizedKey, Value: separatorIndex >= 0 ? normalizedKey.substring(separatorIndex + 3) : normalizedKey };
            this.deliveryPoints = [...this.deliveryPoints, match].sort((a, b) => a.Value.localeCompare(b.Value));
        }

        this.bookingRequest.salesOrder.deliveryPointId = match.Key;
    }

    private getHistoryCopyDeliveryPointId(copyData: any): string {
        const history = copyData?.history;
        const fromHeader = history?.DeliveryPointId || history?.deliveryPointId;
        if (fromHeader) {
            return fromHeader.toString().trim();
        }

        for (const historyItem of (copyData?.items || [])) {
            const fromRemarks = this.getHistoryCopyRemarkValue(historyItem, this.deliveryPointRemarksNumber);
            if (fromRemarks) {
                return fromRemarks.trim();
            }
        }

        return '';
    }

    private applyCopiedBillToCustomerOverride() {
        if (!this.copiedBillToCustomerId || this.bookingRequest.billToCustomer?.nameId === this.copiedBillToCustomerId) {
            return;
        }

        const billToRequest = new CustomerRequest();
        billToRequest.name = this.copiedBillToCustomerId;

        this.customerServiceProvider.GetCustomer(billToRequest, (response) => {
            if (response.length !== 1) {
                return;
            }

            this.bookingRequest.billToCustomer = response[0];
            this.customerPriceLevel = this.copiedPriceLevel || (this.bookingRequest.billToCustomer && this.bookingRequest.billToCustomer.priceLevel ? this.bookingRequest.billToCustomer.priceLevel : this.defaultPriceLevel);
            if (this.isAutoPost) {
                this.emailContent = new EmailContent(this.bookingRequest.billToCustomer.mailToEmails, PDFLinkPlaceHolder, this.isAutoPost);
            }
            this.getCreditDetails(this.bookingRequest.billToCustomer);
        }, () => {
            // Keep the ship-to customer's default bill-to that was already resolved.
        });
    }

    private getHistoryCopyOrderType(history: any): string {
        const orderType = history?.PickupDelivery || history?.OrderType || history?.orderType;
        return orderType ? orderType.toString().trim() : '';
    }

    private getHistoryCopyPriceLevel(history: any): string {
        const priceLevel = history?.PriceLevel
            ?? history?.priceLevel
            ?? history?.CustomerPriceLevel
            ?? history?.customerPriceLevel;

        return (priceLevel === undefined || priceLevel === null || priceLevel === '') ? '' : priceLevel.toString();
    }

    private inferHistoryCopyPriceLevel(historyItem: any, catalogItem: any): string {
        const historyPrice = this.getHistoryCopyItemPrice(historyItem);
        const priceLevel1 = Number(catalogItem?.priceLevel1);
        const priceLevel2 = Number(catalogItem?.priceLevel2);

        if (!historyPrice || isNaN(priceLevel1) || isNaN(priceLevel2) || priceLevel1 === priceLevel2) {
            return '';
        }

        return Math.abs(historyPrice - priceLevel2) < Math.abs(historyPrice - priceLevel1) ? '2' : '1';
    }

    private getHistoryCopyCustomerId(data: any): string {
        return data?.history?.CustomerId
            || data?.history?.CustomerID
            || data?.history?.NameId
            || data?.history?.ClientId
            || '';
    }

    private getHistoryCopyItemId(item: any): string {
        return item?.ProductId || item?.itemId || item?.Id || item?.id || '';
    }

    private getHistoryCopyItemQuantity(item: any): number {
        const quantity = Number(item?.Quantity ?? item?.quantity ?? item?.Qty ?? 0);
        return isNaN(quantity) ? 0 : quantity;
    }

    private getHistoryCopyItemPrice(item: any): number {
        const price = Number(item?.Price ?? item?.price ?? 0);
        return isNaN(price) ? 0 : price;
    }

    private getHistoryCopyRemarkValue(historyItem: any, remarksNumber: string): string {
        if (!remarksNumber) {
            return '';
        }

        // The API's casing of this field and the type of RemarksNumber (string vs number) are not guaranteed.
        const rawKey = Object.keys(historyItem || {}).find(key => key.toLowerCase() === 'orderlineremarksjson');
        const raw = rawKey ? historyItem[rawKey] : null;
        if (!raw) {
            return '';
        }

        try {
            const remarks = typeof raw === 'string' ? JSON.parse(raw) : raw;
            const target = remarksNumber.toString().trim();
            const match = Array.isArray(remarks) ? remarks.find(r => (r?.RemarksNumber ?? '').toString().trim() === target) : null;
            return (match?.RemarksValue ?? '').toString();
        } catch {
            return '';
        }
    }

    private resetCopiedOrderItemDates(item: ItemDetails): ItemDetails {
        const endDateYear = new Date(Date.now()).getFullYear();
        const endDateMonth = new Date(Date.now()).getMonth() + 1;
        const endDateDate = new Date(Date.now()).getDate();

        item.startDate = new Date(Date.now());
        item.endDate = new Date(endDateYear, endDateMonth, endDateDate);
        this.setBeginingAndEndDateForItem(item);
        return item;
    }

    private openCopiedOrderInReview() {
        this.isLinear = false;
        this.openCopiedOrderReview = true;

        Promise.resolve().then(() => {
            this.setActiveStep(this.getReviewStepIndex());
            this.openCopiedOrderReview = false;
        });
    }

    private setActiveStep(index: number) {
        this.activeStepIndex = index;
        if (this.stepper) {
            this.stepper.selectedIndex = index;
        }
    }

    private getStatusStepIndex(): number {
        return this.isSalesProUser && this.isfarmAndFields ? 2 : 1;
    }

    private getProductsStepIndex(): number {
        return this.getStatusStepIndex() + 1;
    }

    private getReviewStepIndex(): number {
        if (this.stepper && this.stepper.steps) {
            return Math.max(this.stepper.steps.length - 1, 0);
        }

        return this.isSalesProUser && this.isfarmAndFields ? 4 : 3;
    }

    receiveItems($event) {
        console.log($event);
        this.items = $event;
    }
    itemSelection($event) {
        this.setActiveStep(this.getProductsStepIndex());

        this.items = null;
        this.selectedItem = $event;
        //this.selectedItem.itemBalance.OnHandQuantity = 0;
        this.setBeginingAndEndDateForItem(this.selectedItem);
        // this.setBeginingAndEndDateForItem(this.selectedItem);
        // let orderLine = this.productsFormGroup.get('orderLineRemarks');
        // orderLine.setValidators(Validators.required);
        // orderLine.updateValueAndValidity();
    }

    getRequiredOrderFields(data) {
        let feild1 = data.filter(d => d.SetupToken.includes('REQUIRE_ORDER_FIELD1'))[0].SetupValue;
        let feild2 = data.filter(d => d.SetupToken.includes('REQUIRE_ORDER_FIELD2'))[0].SetupValue;
        let feild3 = data.filter(d => d.SetupToken.includes('REQUIRE_ORDER_FIELD3'))[0].SetupValue;

        if (feild1 == '1' || feild1 == '3') {
            this.orderField1 = this.orderField1;
            let controlfeild1 = this.statusFormGroup.get('orderField1');
            controlfeild1.setValidators(Validators.required);
            controlfeild1.updateValueAndValidity();
        }
        if (feild2 == '1' || feild2 == '3') {
            this.orderField2 = this.orderField2;
            let controlfeild2 = this.statusFormGroup.get('orderField2');
            controlfeild2.setValidators(Validators.required);
            controlfeild2.updateValueAndValidity();
        }
        if (feild3 == '1' || feild3 == '3') {
            this.orderField3 = this.orderField3;
            let controlfeild3 = this.statusFormGroup.get('orderField3');
            controlfeild3.setValidators(Validators.required);
            controlfeild3.updateValueAndValidity();
        }
    }
    getOrderStatus(data) {
        data.filter(d => d.SetupToken.includes('ORDER_PENDING_REASON')).forEach((status, i) => {
            let count = i + 1;
            if (status.SetupToken.includes(count)) {
                this.orderStatuses.push({ id: count.toString(), value: status.SetupValue })
            }
        });
    }
    getOrderFields(data) {
        this.orderField1 = data.filter(d => d.SetupToken.includes("ORDER_FIELD1_LABEL"))[0].SetupValue;
        this.orderField2 = data.filter(d => d.SetupToken.includes("ORDER_FIELD2_LABEL"))[0].SetupValue;
        this.orderField3 = data.filter(d => d.SetupToken.includes("ORDER_LINE_FIELD_LABEL"))[0].SetupValue;
        this.sellingPrice1Label = data.filter(d => d.SetupToken.includes("SELLING_PRICE1_LABEL"))[0].SetupValue;
        this.sellingPrice2Label = data.filter(d => d.SetupToken.includes("SELLING_PRICE2_LABEL"))[0].SetupValue;
        this.getRequiredOrderFields(data);
    }
    getDefaultPriceLevel(data) {
        this.defaultPriceLevel = data.filter(d => d.SetupToken.includes("PRICE_LEVEL_DEF"))[0].SetupValue;
    }
    getDefaultDelivery(data) {
        const defaultOrderType = data.filter(d => d.SetupToken.includes('SALES_ORD_DELIVERY_DEF'))[0].SetupValue;
        this.bookingRequest.salesOrder.orderType = this.copiedOrderType || defaultOrderType;
    }
    async onStatusSubmit() {
        // Only create a delivery point when the user is actually adding one; selecting an existing one must not.
        const newDeliveryPointName = (this.bookingRequest.salesOrder.newDeliveryPoint.DeliveryPointName || '').toString().trim();
        const isNewDeliveryPoint = this.isSalesProUser
            && this.bookingRequest.salesOrder.orderType == 'D'
            && this.showAddNewDeliveryPointForm
            && !!newDeliveryPointName
            && !this.deliveryPoints.some(x => x.Value == newDeliveryPointName);
        if (isNewDeliveryPoint) {
            this.bookingRequest.salesOrder.newDeliveryPoint.CustomerId = this.bookingRequest.customerInfo.Id;
            try {
                let res: any = await this.staging.SaveCustomerDeliveryPoint([this.bookingRequest.salesOrder.newDeliveryPoint]);
                if (res.TransactionObject && res.TransactionObject.Success && res.TransactionObject.Data) {
                    let item = res.TransactionObject.Data[0];
                    const deliveryPointKey = StagingServiceProvider.BuildDeliveryPointKey(item.DeliveryLocationId, item.DeliveryPointName);
                    this.deliveryPoints.push({ Key: deliveryPointKey, Value: item.DeliveryPointName });
                    this.deliveryPoints = [...this.deliveryPoints].sort((a, b) => a.Value.localeCompare(b.Value));
                    this.bookingRequest.salesOrder.deliveryPointId = deliveryPointKey;
                    this.showAddNewDeliveryPointForm = false;
                }

            }
            catch (ex) {
                console.log(ex);
            }
        }
        else if (this.isSalesProUser && this.showAddNewDeliveryPointForm && newDeliveryPointName) {
            const existing = this.deliveryPoints.find(x => x.Value == newDeliveryPointName);
            if (existing) {
                this.bookingRequest.salesOrder.deliveryPointId = existing.Key;
                this.showAddNewDeliveryPointForm = false;
            }
        }

        // Items carry the delivery point in their remarks, so refresh any that were added before it changed.
        this.addedItems.forEach(item => this.prepareOrderItemForDraft(item, !!(item as any).isCopiedPriceLocked));

        this.statusFormGroup.get('orderField1').markAsTouched();
        this.statusFormGroup.get('orderField2').markAsTouched();
        this.statusFormGroup.get('orderField3').markAsTouched();

        this.statusFormGroup.get('deliveryPointName').markAsTouched();
        this.statusFormGroup.get('allowsHeavyTruck').markAsTouched();
    }
    checkInput($event) {
        let value = $event.target.value;
        let e = <KeyboardEvent>$event;
        let input = $event.target.name;
        let decimalLimit;
        if (input == "price") {
            decimalLimit = this.unitPricePrecision;
        } else if (input == "quantity") {
            decimalLimit = this.productQuantityPrecision;
        }
        let decimalPosition = this.countDecimals(value);
        if (decimalPosition > decimalLimit) {
            value = value.substring(0, value.length - (decimalPosition - decimalLimit));
            $event.target.value = value;
            if (input == "price") {
                this.selectedItem.price = value;
            }
            if (input == "quantity") {
                this.selectedItem.quantity = value;
            }

            e.preventDefault();
        }
    }
    getPricision() {
        this.blockUI.start();
        this.appSetting.GetDecimalPricision().then((response) => {
            this.unitPricePrecision = response.UnitPricePrecision;
            this.productQuantityPrecision = response.ProductQuantityPrecision;
            this.stopBlockUI();

        }).catch((error) => {
            if (error)
                this.alertService.error(error.Message);
            this.stopBlockUI();
        })
    }
    countDecimals(value: any) {
        if (Math.floor(value) === value) return 0;
        if (value.indexOf(".") > -1) {
            return value.toString().split(".")[1].length;
        } else {
            return 0;
        }
    }
    CalculateAmount() {
        if (isNaN(this.selectedItem.price) || isNaN(this.selectedItem.quantity)) {
            this.selectedItem.amount = 0;
            return;
        }
        this.selectedItem.amount = Number((this.selectedItem.price * this.selectedItem.quantity));
        if (this.selectedItem.itemBalance.OnHandQuantity > Number(this.selectedItem.quantity)) {
            this.alertService.warning("No Inventory on hand", false, true);
        }

    }
    onFocus($event) {
        let value = $event.target.value;
        if (value === 0 || value === '0') {
            this.selectedItem.quantity = null;
            $event.target.value = null;
        }
    }
    onBlur($event) {
        let value = $event.target.value;
        if (value === null || value === '') {
            this.selectedItem.quantity = 0;
            $event.target.value = 0;
        }
    }
    validateItemDate(selectdItem: ItemDetails) {
        this.alertService.clear();
        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth();
        var endDateDate = new Date(Date.now()).getDate();
        var currentDate = new Date(endDateYear, endDateMonth, endDateDate);


        if ((selectdItem.startDate < currentDate) || (selectdItem.startDate > selectdItem.endDate)
            || (selectdItem.startDate.getFullYear() == selectdItem.endDate.getFullYear()
                && selectdItem.startDate.getMonth() == selectdItem.endDate.getMonth()
                && selectdItem.startDate.getDay() == selectdItem.endDate.getDay())) {
            this.alertService.error("Invalid date", false, true);
            return false;
        }
        return true;
    }
    addItem(stepper: MatStepper = undefined) {
        if (!this.validateItemDate(this.selectedItem)) return;
        this.blockUI.start();
        var response: any = {
            overrideMinWithWarningMessage: "Current price is less than minimum price. Override It?",
            overrideMinRestrictedMessage: "Current price is less than minimum price.",
            overrideMaxWithWarningMessage: "Current price is greater than maximum price. Override It?",
            overrideMaxRestrictedMessage: "Current price is greater than maximum price."
        };
        this.itemServiceProvider.IsPriceOverrideAllowed().then((data) => {
            this.selectedItem.maximumPrice = this.selectedItem.maximumPrice == 0 ? Number.MAX_VALUE : this.selectedItem.maximumPrice;
            if (this.selectedItem.price < this.selectedItem.minimumPrice || this.selectedItem.price > this.selectedItem.maximumPrice) {
                let errorMessage = "";
                if (data.overrideRestricted) {
                    if (this.selectedItem.price < this.selectedItem.minimumPrice) {
                        errorMessage = response.overrideMinRestrictedMessage;
                    } else if (this.selectedItem.price > this.selectedItem.maximumPrice) {
                        errorMessage = response.overrideMaxRestrictedMessage;
                    }
                }
                else if (data.overrideWithWarning) {
                    if (this.selectedItem.price < this.selectedItem.minimumPrice) {
                        errorMessage = response.overrideMinWithWarningMessage;
                    } else if (this.selectedItem.price > this.selectedItem.maximumPrice) {
                        errorMessage = response.overrideMaxWithWarningMessage;
                    }
                }
                if (data.overrideRestricted) {
                    var index = this.addedItems.indexOf(this.selectedItem, 0);
                    if (index > -1) {
                        this.addedItems.splice(index, 1);
                        this.UpdateTotal();
                    }
                    utils.confirmationDialog('Warning', errorMessage, 'Close', (result) => {
                        var index = this.addedItems.indexOf(this.selectedItem, 0);
                        if (index > -1) {
                            this.addedItems.splice(index, 1);
                            this.UpdateTotal();
                        }
                    }, false);
                }
                else if (data.overrideWithWarning) {
                    utils.confirmationDialog('Confirmation', errorMessage, 'Confirm', (result) => {
                        if (result == 'Confirm') {
                            this.addItemComplete(stepper);
                        }
                        else {
                            var index = this.addedItems.indexOf(this.selectedItem, 0);
                            if (index > -1) {
                                this.addedItems.splice(index, 1);
                                this.UpdateTotal();
                            }
                        }
                    });
                }
                else {
                    this.addItemComplete(stepper);
                }
            }
            else {
                this.addItemComplete(stepper);
            }

        }).catch(e => {
            this.alertService.error(e);
        }).finally(() => {
            this.blockUI.stop();
        })
        //this.alertService.success("Record saved successfully.", false, true);
    }
    addItemComplete(stepper: MatStepper = undefined, showSuccess: boolean = true) {
        this.productsFormGroup.get('orderLineRemarks').markAsTouched();

        var index = this.addedItems.indexOf(this.selectedItem, 0);
        if (index > -1) {
            this.addedItems.splice(index, 1);
        }
        this.selectedItem = this.prepareOrderItemForDraft(this.selectedItem, false);
        this.addedItems.push(this.selectedItem);

        if (this.addedItems.length > 0) {
            var LocationChangeAllow = (localStorage.getItem("BlockLocation")) ? localStorage.getItem("BlockLocation") === 'true' ? true : false : false;
            if (!LocationChangeAllow) {
                localStorage.setItem("BlockLocation", 'true');
            }

        }
        //this.setBeginingAndEndDateForItem(this.selectedItem)
        this.selectedItem = null;
        if (showSuccess) {
            this.alertService.success('Item added successfully.', false, true);
        }
        this.UpdateTotal(stepper);
    }

    private prepareOrderItemForDraft(item: ItemDetails, lockCopiedPrice: boolean = false): ItemDetails {
        item.itemBalance.OnHandQuantity = parseFloat(item.itemBalance.OnHandQuantity.toString());
        item.price = parseFloat(item.price.toString());
        item.amount = Number(item.price * item.quantity);
        (item as any).isCopiedPriceLocked = lockCopiedPrice;

        if (this.appSetting.warehouseProConfig.WarehousePro == true) {
            item.shipmentType = this.bookingRequest.salesOrder.orderType == "D" ? "delivery" : "pickup";
            item.shipmentTypeRemarksNumber = this.shipmentTypeRemarksNumber;

            item.shipmentTime = item.shipmentTime;
            item.shipmentTimeRemarksNumber = this.shipmentTimeRemarksNumber;

            item.deliveryPointId = this.bookingRequest.salesOrder.orderType == 'D' ? this.bookingRequest.salesOrder.deliveryPointId : null;
            item.deliveryPointRemarksNumber = this.deliveryPointRemarksNumber;

            item.orderLineRemarksJson = [];
            item.orderLineRemarksJson.push({ RemarksNumber: item.shipmentTypeRemarksNumber, RemarksValue: item.shipmentType });
            item.orderLineRemarksJson.push({ RemarksNumber: item.shipmentTimeRemarksNumber, RemarksValue: item.shipmentTime });
            item.orderLineRemarksJson.push({ RemarksNumber: item.deliveryPointRemarksNumber, RemarksValue: item.deliveryPointId });

            item.orderLineRemarksJson = JSON.stringify(item.orderLineRemarksJson);
        }

        item.lineRemarks = item.orderlineRemarks;
        return item;
    }
    setBeginingAndEndDateForItem(item: ItemDetails) {
        if (this.productCategoryDateRange) {
            let itemConfig = this.productCategoryDateRange.find(i => i.Name == item.productCategory)
            if (itemConfig) {
                let value = JSON.parse(itemConfig.Value);
                if (value) {
                    var endDateYear = new Date(Date.now()).getFullYear();
                    var endDateMonth = new Date(Date.now()).getMonth();
                    var endDateDate = new Date(Date.now()).getDate();
                    var currentDate = new Date(endDateYear, endDateMonth, endDateDate);
                    item.startDate = item.startDate;
                    let configStartDate = new Date(value.BeginingDate);
                    let configEndDate = new Date(value.EndingDate);
                    if (configStartDate > currentDate) {
                        item.startDate = configStartDate; //value.BeginingDate ? value.BeginingDate : item.startDate;
                    }
                    item.endDate = item.endDate;
                    if (configEndDate > item.startDate) {
                        item.endDate = configEndDate;//value.EndingDate ? value.EndingDate : item.endDate;
                    }
                }
            }
        }

    }
    editItem(item) {
        this.selectedItem = item;
        this.isEditItem = true;
        this.UpdateTotal();
    }
    removeItem(item) {
        utils.confirmationDialog('Confirmation', 'Are you sure you want to delete this item?', 'Confirm', (result) => {
            if (result == 'Confirm') {
                var index = this.addedItems.indexOf(item, 0);
                if (index > -1) {
                    this.addedItems.splice(index, 1);
                }
                this.alertService.success('Item deleted successfully.', false, true);
                if (this.addedItems.length == 0)
                    localStorage.removeItem('BlockLocation');
                this.UpdateTotal();
            }
        });
    }
    updateItem(stepper: MatStepper) {
        if (!this.validateItemDate(this.selectedItem)) return;
        this.blockUI.start();
        var response: any = {
            overrideMinWithWarningMessage: "Current price is less than minimum price. Override It?",
            overrideMinRestrictedMessage: "Current price is less than minimum price.",
            overrideMaxWithWarningMessage: "Current price is greater than maximum price. Override It?",
            overrideMaxRestrictedMessage: "Current price is greater than maximum price."
        };
        this.itemServiceProvider.IsPriceOverrideAllowed().then((data) => {
            this.selectedItem.maximumPrice = this.selectedItem.maximumPrice == 0 ? Number.MAX_VALUE : this.selectedItem.maximumPrice;
            if (this.selectedItem.price < this.selectedItem.minimumPrice || this.selectedItem.price > this.selectedItem.maximumPrice) {
                let errorMessage = "";
                if (data.overrideRestricted) {
                    if (this.selectedItem.price < this.selectedItem.minimumPrice) {
                        errorMessage = response.overrideMinRestrictedMessage;
                    } else if (this.selectedItem.price > this.selectedItem.maximumPrice) {
                        errorMessage = response.overrideMaxRestrictedMessage;
                    }
                }
                else if (data.overrideWithWarning) {
                    if (this.selectedItem.price < this.selectedItem.minimumPrice) {
                        errorMessage = response.overrideMinWithWarningMessage;
                    } else if (this.selectedItem.price > this.selectedItem.maximumPrice) {
                        errorMessage = response.overrideMaxWithWarningMessage;
                    }
                }
                if (data.overrideRestricted) {
                    utils.confirmationDialog('Warning', errorMessage, 'Close', (result) => {
                        var index = this.addedItems.indexOf(this.selectedItem, 0);
                        if (index > -1) {
                            this.addedItems.splice(index, 1);
                            this.UpdateTotal();
                        }
                    }, false);
                }
                else if (data.overrideWithWarning) {
                    utils.confirmationDialog('Confirmation', errorMessage, 'Confirm', (result) => {
                        if (result == 'Confirm') {
                            stepper.next();
                            this.updateItemComplete();

                        }
                    });
                }
                else {
                    stepper.next();
                    this.updateItemComplete();
                }
            }
            else {
                stepper.next();
                this.updateItemComplete();
            }

        }).catch(e => {
            this.alertService.error(e);
        }).finally(() => {
            this.blockUI.stop();
        })
    }

    updateItemComplete() {
        this.isEditItem = false;
        this.UpdateTotal();
    }
    hideShowAllItems(status) {
        this.isShowAllItems = status;
    }
    UpdateTotal(stepper: MatStepper = undefined) {
        this.totalAmount = 0;
        this.addedItems.forEach((item => {
            this.totalAmount = this.totalAmount + item.amount;
        }))
        if (stepper) stepper.next();
    }
    validateDates() {
        this.alertService.clear();
        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth();
        var endDateDate = new Date(Date.now()).getDate();
        var currentDate = new Date(endDateYear, endDateMonth, endDateDate);

        if ((this.bookingRequest.startDate < currentDate) || (this.bookingRequest.expiryDate < currentDate)) {
            this.alertService.error("Invalid Check date", false, true);
            return false;
        }

        if (this.bookingRequest.startDate >= this.bookingRequest.expiryDate) {
            // this.alertService.error("Invalid Check date", false, true);
            this.bookingRequest.expiryDate = this.bookingRequest.startDate;
            return false;
        }

        return true;
    }
    setDefaultDates() {
        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth() + 1;
        var endDateDate = new Date(Date.now()).getDate();

        this.bookingRequest.startDate = new Date(Date.now());
        this.minDate = new Date(Date.now());
        this.bookingRequest.expiryDate = new Date(endDateYear, endDateMonth, endDateDate);
    }
    getOrderRemarks(visible?: boolean) {
        this.blockUI.start();
        this.bookingService.GetOrderRemarksConfiguration(visible).then((items) => {
            this.bookingRequest.salesOrder.orderRemarks = items;
            this.bookingRequest.salesOrder.orderRemarks.forEach(orderRemark => {
                orderRemark.formGroup = `remarkField${orderRemark.orderRemarksId}`
                if (orderRemark.required) {
                    this.reviewFormGroup.addControl(orderRemark.formGroup, new UntypedFormControl('', Validators.required));
                } else {
                    this.reviewFormGroup.addControl(orderRemark.formGroup, new UntypedFormControl(''));
                }
            })

            this.stopBlockUI();
        }).catch((error) => {
            Sentry.captureMessage("Handled Error" + JSON.stringify(error));
            console.log(error);
            this.stopBlockUI();
            this.alertService.error(error.Message);
        })
    }
    sign() {
        this.OrderSignatureRequiredStatus = this.isSignatureRequired ? true : false;
        this.isSign = true;

    }
    resign() {
        this.OrderSignatureRequiredStatus = this.isSignatureRequired ? true : false;
        this.signatureImage = undefined;
        this.signaturePad.clear();
    }
    clearSign(event: any) {
        this.OrderSignatureRequiredStatus = this.isSignatureRequired ? true : false;
        this.signaturePad.clear();
    }
    showImage() {
        this.bookingRequest.salesOrder.signatureImage = this.signatureImage;
        this.OrderSignatureRequiredStatus = false;
    }
    onReviewSubmit(event) {
        // if (event.submitter.className.indexOf("ta-order-signatureclear") !== -1)
        //     return;

        // if (event.submitter.className.indexOf("text-white btn btn-success") !== -1)
        // return;

        if (!this.addedItems.length) {
            this.alertService.error('Cannot proceed, no inventory items were added', false, true);
            return;
        }
        // if (event.submitter.classList.contains('ta-order-signatureclear')) {
        //     return false;
        // }
        this.blockUI.start();
        let transaction = this.startOrderTransaction('Transaction:(Order)');

        // this.addedItems.forEach((item) =>{
        //     this.orderlineRemarks[this.shipmentTimeRemarksNumber] = item.shipmentTime;
        //     item.lineRemarks =  item.lineRemarks + this.orderlineRemarks;
        // })

        // this.bookingRequest.approveBookingRequest.status = null;
        // this.bookingRequest.pendingAgreementConfig = this.pendingAgreementConfig.pendingAgreementStatus;
        // if (this.pendingAgreementConfig.pendingAgreementStatus == true)
        //     this.bookingRequest.approveBookingRequest.status = this.pendingAgreementConfig.pendingOrderStatus;
        if (!this.reviewFormGroup.valid) {
            this.alertService.error(ErrorMessages.FormValidation, false, true);
            // this.alertService.error("Invalid data", false, true);
            this.blockUI.stop();
            return false;
        }
        // if (this.pendingAgreementConfig.pendingAgreementStatus == true) {
        this.bookingRequest.toEmails = this.bookingRequest.billToCustomer.mailToEmails;
        // }
        this.events.publish("event:blockUnblockLoctionChange");
        this.bookingRequest.endDate = this.bookingRequest.expiryDate;
        this.bookingRequest.bookingItems = this.addedItems;

        this.bookingRequest.bookingItems.forEach((item) => {
            var startDT = new Date(item.startDate);
            var startDateYear = startDT.getFullYear();
            var startDateMonth = startDT.getMonth();
            var startDateDate = startDT.getDate();
            var startDateHour = new Date().getHours();
            var startDateMin = new Date().getMinutes();
            var startDateSec = new Date().getSeconds();
            item.startDate = new Date(startDateYear, startDateMonth, startDateDate, startDateHour, startDateMin, startDateSec);

            var endDT = new Date(item.endDate);
            var endDateYear = endDT.getFullYear();
            var endDateMonth = endDT.getMonth();
            var endDateDate = endDT.getDate();
            item.endDate = new Date(endDateYear, endDateMonth, endDateDate, startDateHour, startDateMin, startDateSec);
        });
        // if(this.isAutoPost || !this.bookingRequest.approveBookingRequest.status) {3
        this.bookingRequest.billToCustomer.priceLevel = this.customerPriceLevel;

        this.bookingRequest.salesOrder.documentNumber = this.requireTheirDocumentNumber == true ? this.bookingRequest.salesOrder.documentNumber : "";
        this.bookingService.PostBooking(this.bookingRequest, this.isAutoPost ).then((response) => {
            let createdDateTime = response.CreatedDateTime;
            if (this.isAutoPost) {
                this.onPostBookingResponse(response, 'Order', transaction);
            }
            if (response.TransactionObject && response.TransactionObject.Success && !(response.ErrorMessage)) {
                this.blockUI.stop();
                this.router.navigate(['bookingcomplete', { createdDateTime: createdDateTime, mode: 'Order', bookingReceiptNumber: response.TransactionObject.Data }]);
            } else {
                this.blockUI.stop();
            }
        }).catch((error) => {
            Sentry.captureMessage("Handled Error" + JSON.stringify(error));
            console.log(error);
            this.blockUI.stop();
            this.alertService.error(error.Message);
            this.blockUI.stop();
        }).finally(() => { this.blockUI.stop() });
        // } else if(this.bookingRequest.approveBookingRequest.status) {

        //     this.gatewayService.postBooking(this.bookingRequest).then((data) => {
        //         this.onPostBookingResponse(data, 'Order', transaction);

        //     }).catch((error) => {
        //         this.onPostBookingResponse(error, 'Order', transaction);

        //     });
        // }
    }
    onPostBookingResponse(response: any, mode: string, transaction: any) {
        this.blockUI.start();
        transaction?.finish?.();
        let createdDateTime = response.CreatedDateTime;
        try {
            if (response.ErrorMessage) {
                Sentry.captureMessage("Handled Error: " + JSON.stringify(response));
                if (response.ErrorMessage.toUpperCase().includes('LICENSE'))
                    return this.alertService.error(response.ErrorMessage);
                return this.alertService.error(`${response.ErrorMessage}`);
            }
            if (!response.TransactionObject)
                return this.alertService.error("Agris Service error. Posting was not successful.");

            let documentNumber = response.TransactionObject.BookingNumber ? response.TransactionObject.BookingNumber : response.Document;

            if (this.pendingAgreementConfig.pendingAgreementStatus == true && this.isAutoPost) {

                let bookingId = response.TransactionObject.Data;
                this.printBookingPdf(bookingId, mode, response.TransactionMessage, documentNumber, createdDateTime);

            } else {
                this.blockUI.stop();
                return this.router.navigate(['bookingcomplete', { createdDateTime: createdDateTime, documentNumber: documentNumber, mode: mode, bookingReceiptNumber: response.TransactionMessage }]);
            }
        }
        catch (ex) {
            this.blockUI.stop();
            Sentry.captureMessage("Handled Error: " + JSON.stringify(ex));
            return this.alertService.error("Agris Service error. Posting was not successful.");
        }
    }
    printBookingPdf(bookingId: any, mode: any, bookingReceiptNumber: any, documentNumber, createdDateTime) {
        let type = "Order";
        let getPdfBit: boolean = false;
        // this.blockUI.start();
        // this.requestHelper.refreshAgrisLicenseCounter().then((res) => {
        // this.blockUI.start();

        this.gatewayService.printBooking(bookingId, getPdfBit, false, (response: any) => {
            this.blockUI.stop();
            if (response.TransactionObject) {
                let encryptedId = this.cryptoService.encryptString(bookingId.toString())
                let pdfLink = `${Utils.GetSalesReviewRemoteServer()}/BookingsV2/GetPrintForm?isPending=${getPdfBit}&id=${encodeURIComponent(encryptedId)}`;
                let encodeURI = encodeURIComponent(pdfLink)

                let mailToStr = this.emailContent.mailTostring.replace(PDFLinkPlaceHolder, encodeURI);
                mailToStr = mailToStr.replace(TransactionType, type);

                // jira item ACC-1539  After daily Standup conformation Contract Word changes to Sales Order in Case of auto Approve//
                mailToStr = mailToStr.replaceAll("contract", "Sales Order");
                // jira item ACC-1539 //

                const message = { type: 'OPEN_EMAIL', data: { emailContent: this.emailContent, mailToStr: mailToStr }, name: 'order' };
                window.parent.postMessage(message, "*");

                location.href = mailToStr;

                this.router.navigate(['bookingcomplete', { createdDateTime: createdDateTime, documentNumber: documentNumber, mode: mode, bookingReceiptNumber: bookingReceiptNumber, BookingID: encryptedId, isAutoApprove: getPdfBit }]);
            } else
                this.router.navigate(['bookingcomplete', { createdDateTime: createdDateTime, documentNumber: documentNumber, mode: mode, bookingReceiptNumber: bookingReceiptNumber, errorType: [BookingPostingErrorTypes.PrintFailure] }]);
        }, (error: any) => {
            this.blockUI.stop();
            Helpers.LogError(error);
            Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
            return this.alertService.error("Agris Service error. Printing Pdf was not successful.");
        });
        // }).catch((err) => {
        //     // console.log(err);
        //     Helpers.LogError(err);
        //     this.blockUI.stop();
        // });

    }

    getUsersPermission() {
        this.bookingService.GetUserPermissions().then((permissions) => {
            this.isAutoPost = false;
            permissions.forEach(permission => {
                if (permission.AssignedUserId.trim() == JSON.parse(localStorage.getItem('agrisLicense')).username) {
                    this.isAutoPost = permission.AutoApproveOrder;
                }
            });
        });
    }
    GetPendingAgreementSettings() {
        //this.blockUI.start();
        this.appSetting.GetAppSettingsFromASR(ASRAppSettings.PendingAgreementsConfiguration).then((response) => {
            let data = response.TransactionObject;
            if (data.length) {
                let settingStatus = data.find((x: any) => x.Name == PendingAgreementsConfiguration.PendingAgreementStatus);
                this.pendingAgreementConfig.pendingAgreementStatus = settingStatus && settingStatus.Value ? JSON.parse(settingStatus.Value) : false;

                let selectedEmailType = data.find((x: any) => x.Name == PendingAgreementsConfiguration.SelectedEmailType);
                this.pendingAgreementConfig.emailType = selectedEmailType && selectedEmailType.Value ? selectedEmailType.Value.split('-')[0].trim() : "";

                let selectedOrderStatus: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.SelectedPendingOrderStatus);
                if (selectedOrderStatus && selectedOrderStatus.Value) {
                    this.pendingAgreementConfig.pendingOrderStatus = selectedOrderStatus.Value;
                    this.pendingAgreementConfig.pendingOrderStatusDescription = this.pendingAgreementConfig.pendingAgreementStatus ? "Pending Order" : "";
                }

                let SignatureRequiredStatus: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.SignatureRequiredStatus);
                if (SignatureRequiredStatus && SignatureRequiredStatus.Value) {
                    this.pendingAgreementConfig.PendingSignatureRequiredStatus = SignatureRequiredStatus.Value;
                    this.pendingAgreementConfig.PendingSignatureRequiredStatus = this.pendingAgreementConfig.PendingSignatureRequiredStatus ? SignatureRequiredStatus.Value : false;
                    this.OrderSignatureRequiredStatus = SignatureRequiredStatus.Value.toLowerCase() === 'true' ? true : false;
                    this.isSignatureRequired = SignatureRequiredStatus.Value.toLowerCase() === 'true' ? true : false;
                }

                let ButtonQuote: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.ButtonQuote);
                if (ButtonQuote && ButtonQuote.Value) {
                    this.pendingAgreementConfig.ButtonQuote = ButtonQuote.Value;
                    this.pendingAgreementConfig.ButtonQuote = this.pendingAgreementConfig.ButtonQuote.length > 0 ? ButtonQuote.Value : false;
                    this.QuoteButtonName = ButtonQuote.Value;
                } else {
                    this.QuoteButtonName = "Quote";
                }
            }
            //this.blockUI.stop();
        }).catch((error) => {
            if (error)
                this.alertService.error(error.Message);
            //this.blockUI.stop();
        });
    }
    onEnter(stepper: MatStepper) {
        if (this.selectedItem.quantity <= 0 || this.selectedItem.amount <= 0 || !this.validateItemDate(this.selectedItem)) {
            return;
        } else {
            this.addItem(stepper);
        }
    }
    onStepChange(event) {
        this.activeStepIndex = event.selectedIndex;

        if (event.selectedIndex == this.getReviewStepIndex() && this.addedItems.length == 0) {
            this.isLinear = false;
            // this.stepper.steps._results[2].completed = true;
            // this.stepper.disableRipple = true; 
            // this.stepper.selectedIndex = 2;          
            console.log(this.isLinear);

        }

        if (event.selectedIndex == this.getStatusStepIndex()) {
            console.log(this.bookingRequest.salesOrder.deliveryPointId);
        }
    }
    receiveFarmAndFields(response, stepper: MatStepper) {
        this.selectedFarmAndField = response.name;
        this.bookingRequest.farm = response.farmCode;
        this.bookingRequest.farmName = response.farmName;
        this.bookingRequest.field = response.fieldCode;
        this.bookingRequest.fieldName = response.fieldName;
        this.bookingRequest.clientId = response.clientId;
        this.splits = response.splits;
        this.showFarmAndFields = true;
        if (this.selectedFarmAndField != 'No farm and fields available.')
            stepper.next();
    }
    getFarmAndField(stepper: MatStepper) {
        if (this.isSalesProUser) {
            this.isfarmAndFields = true;
            stepper.next();
        } else {
            stepper.next();
            stepper.next();
        }
    }
    ngOnDestroy() {
        localStorage.removeItem('BlockLocation');
    }
    cancel() {
        this.selectedItem = null;
        localStorage.removeItem('BlockLocation');
    }
}


